import { Lookup } from './lookup.interface';
export interface LiveWithApplicantLookup extends Lookup {
  livesWithApplicant?: boolean;
}
export const LiveWithApplicantTypes: { [name: string]: LiveWithApplicantLookup } = {
  fullTime: { code: 'fullTime', displayValue: 'Yes - Full-time', livesWithApplicant: true },
  partTime: { code: 'partTime', displayValue: 'Yes - Part-time', livesWithApplicant: true },
  notLivingWithApplicant: { code: 'notLivingWithApplicant', displayValue: 'No', livesWithApplicant: false },
};

export const SpouseLivesWithApplicantTypes: { [name: string]: LiveWithApplicantLookup } = {
  yes: { code: 'yes', displayValue: 'Yes', livesWithApplicant: true },
  noFacility: {
    code: 'noFacility',
    displayValue: 'No, they live in a facility (e.g. continuing care home) in Alberta',
    livesWithApplicant: false,
  },
  noOutsideAlberta: {
    code: 'noOutsideAlberta',
    displayValue: 'No, they live outside of Alberta',
    livesWithApplicant: false,
  },
};
